import { COLOR, VARIANT } from './types'
import { useMemo } from 'react'

export const useBackground = (color: COLOR, variant: VARIANT) => {
  return useMemo(
    () => (variant === 'outline' ? `outline-${color}` : `bg-${color}`),
    [color, variant],
  )
}
